import moment from 'moment';

const initState = {
    classes: [],
    partner: null
}
const festivalReducer = (state = initState, action) => {
    switch (action.type) {
        case 'SET_PARTNER':
            state.partner = action.partner;
            return state
        case 'MORE_FESTIVAL_CLASSES':
            var allClasses = state.classes.concat(action.classes);
            console.log(allClasses.length)
            var classes = {};
            allClasses = allClasses.filter(function(entry) {
                // if ((entry.start_time + (entry.duration * 60)) < NOW) {
                //     return false
                // }
                if (classes[entry.platformID]) {
                    return false;
                }
                classes[entry.platformID] = true;
                return true;
            });
            // allClasses = Array.from(new Set(allClasses.map((item) => { if (item) { return item.platformID } })))
            
            state.classes = allClasses.sort( (a, b) => {
                if (a.start_time && b.start_time) {
                    return a.start_time - b.start_time
                } else {
                    return 0
                }
            })
            // removeDuplicates(allClasses, "platformID")
            return state;
        default:
            break;
    }

    return state
}

export default festivalReducer;